import { Spinner, Flex, Text } from '@radix-ui/themes';

export const Loader = () => {
  return (
    <Flex className="h-screen w-full items-center justify-center bg-gray-50">
      <Flex direction="column" align="center" gap="6">
        <div className="scale-[2]">
          <Spinner size="3" className="text-primary" />
        </div>
        <Text size="2" weight="medium" className="text-gray-600">
          Loading...
        </Text>
      </Flex>
    </Flex>
  );
};
